
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/car-maintenance/[slug]",
      function () {
        return require("private-next-pages/guides/car-maintenance/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/car-maintenance/[slug]"])
      });
    }
  